import { render, staticRenderFns } from "./grossList.vue?vue&type=template&id=904a6fd8"
import script from "./grossList.vue?vue&type=script&lang=js"
export * from "./grossList.vue?vue&type=script&lang=js"
import style0 from "./grossList.vue?vue&type=style&index=0&id=904a6fd8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports